import { authService } from '@afterpaytouch/portal-api/consumer/auth'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { clearState } from '../../actions'
import { Authentication, AuthenticationErrors } from '../../../model'
import { PasswordResetTwoFactorChallenge } from '@afterpaytouch/portal-api/consumer/auth/types'
import { authenticationSelector, errorSelector, profilingIdSelector, shouldAllowEmailSelector } from './selectors'

/* React Hooks */

export const useIsConsumerAuthenticated = (): boolean => useAppSelector((state) => state.auth.user.status.authenticated)
export const useAuthentication = (): Authentication => useAppSelector(authenticationSelector)

export const useProfilingId = (): string => useAppSelector(profilingIdSelector)

export const useShouldAllowEmail = (): boolean | undefined => useAppSelector(shouldAllowEmailSelector)

export const useLogout = (backToShop: boolean = true): (() => Promise<void>) => {
  const dispatch = useAppDispatch()
  return async () => {
    await dispatch(clearState(backToShop))
  }
}

export const usePasswordResetVerifyCode = (): string => useAppSelector((state) => state.auth.user.passwordResetVerifyCode)
export const usePasswordResetFactorChallenges = (): PasswordResetTwoFactorChallenge[] => useAppSelector((state) => state.auth.user.passwordResetChallenges)

export const {
  useAuthLoginMutation,
  useAuthCheckChallengeMutation,
  useAuthCheckCodeMutation,
  useAuthLogoutEndpointMutation,
  useAuthResetCodeMutation,
  useAuthResetMutation,
  useGet2faCodeMutation,
  useCheck2faCodeMutation,
  endpoints: { authLogin, authLogoutEndpoint, authCheckChallenge, authCheckCode, authReset, authResetCode },
} = authService

export const useAuthError = (): AuthenticationErrors | undefined => useAppSelector(errorSelector)
